import React from 'react';
import { StyledComponent } from '@emotion/styled';
import { ArrowDown, Maximize, Minimize } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Divider, IconButton, IconButtonProps, styled, Theme } from '@mui/material';

const maximizeIcon = <Maximize style={{ width: 18, height: 18 }} />;
const minimizeIcon = <Minimize style={{ width: 18, height: 18 }} />;

interface ExpandCardProps extends IconButtonProps {
  expand?: boolean;
  fullScreen?: boolean;
  toggleFullScreen?: () => void;
}

export const ExpandCard: StyledComponent<ExpandCardProps> = styled(
  ({ expand, fullScreen, toggleFullScreen, ...other }: ExpandCardProps) => {
    const onClickResize = (e: React.MouseEvent) => {
      e.stopPropagation();
      toggleFullScreen!();
    };

    return (
      <Box sx={{ ...flex.row, gap: 2 }}>
        {toggleFullScreen ? (
          <IconButton sx={{ height: 18 }} onClick={onClickResize}>
            {fullScreen ? minimizeIcon : maximizeIcon}
          </IconButton>
        ) : null}
        {!fullScreen && (
          <>
            <Divider flexItem orientation="vertical" sx={{ height: 22 }} />
            <IconButton aria-expanded={expand} aria-label="show more" {...other}>
              <ArrowDown style={iconSize(18)} />
            </IconButton>
          </>
        )}
      </Box>
    );
  }
)<ExpandCardProps>(({ theme, expand }) => ({
  transform: expand ? 'rotate(180deg)' : 'rotate(0deg)',
  padding: 0,
  transition: (theme as Theme).transitions.create('transform', {
    duration: (theme as Theme).transitions.duration.shortest,
  }),
}));
